import { useIntl } from 'react-intl';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { API } from 'src/reactQuery/Api';
import { QUERY_KEYS } from 'src/reactQuery/QueryKeys';
import { postRequest } from 'src/utils/request';
import { useMessageHandler } from 'src/utils/hooks/useMessageHandler';

import messages from '../../messages';

const createCandidateAdditionalFields = async (params: {
  uuid: string;
  attributes: Record<
    string,
    Record<string, boolean | Array<string> | string | null>
  >;
}) => {
  const { uuid, attributes } = params;

  const agile_attributes = Object.entries(attributes).map(([uuid, data]) => {
    const value = data.options ?? data.value;
    return {
      dynamic_field_uuid: uuid,
      answer: value!,
    };
  });
  const payload = { agile_attributes };

  return await postRequest(API.POST.createCandidateDynamicField(uuid), payload);
};

export const useCreateCandidateAdditionalFields = () => {
  const client = useQueryClient();
  const { formatMessage } = useIntl();
  const { handleError, handleSuccess } = useMessageHandler();

  return useMutation({
    mutationFn: createCandidateAdditionalFields,
    onSuccess: () => {
      client.invalidateQueries({
        queryKey: [QUERY_KEYS.FIELDS_CATEGORY],
      });
      client.invalidateQueries({
        queryKey: [QUERY_KEYS.INTERNAL_ATTRIBUTES],
      });
      handleSuccess(formatMessage(messages.attributesSaved));
    },
    onError: handleError,
  });
};
